import { decorativeItemNotice, decorativeItemNoticeTitle } from "@tinkr/shared/product-safety";
import type { AppLocale } from "../i18n";

/**
 * Short "decorative item, not a toy" notice beside ordering and confirmation.
 * The wording is shared across every customer surface and summarises the
 * binding "Decorative items, not toys" section of the Terms.
 */
export function DecorativeItemNotice({ locale, className }: { locale: AppLocale; className?: string }) {
  return (
    <p className={className ? `co-decorative-notice ${className}` : "co-decorative-notice"} role="note">
      <strong>{decorativeItemNoticeTitle(locale)}</strong>
      <span>{decorativeItemNotice(locale)}</span>
    </p>
  );
}
